import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod"

export const channelDefinition = z.union([z.literal("R"), z.literal("G"), z.literal("B"), z.literal("A"), z.number()])

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            sourceImage: anyImageOpResult,
            channel: channelDefinition,
        }),
    },
}
